 export enum AbsenceHistoriqueTypeActionEnum {
Inconnu = 0,
Creation = 1,
Modification = 2,
Suppression = 3,
DemandeAnnulation = 4,
AnnulerDemandeAnnulation = 5,
Validation = 6,
ValidationN1 = 7,
ValidationN2 = 8,
Refus = 9,
RefusN1 = 10,
RefusN2 = 11,
ValidationAnnulation = 12,
ValidationAnnulationN1 = 13,
ValidationAnnulationN2 = 14,
RefusAnnulation = 15,
RefusAnnulationN1 = 16,
RefusAnnulationN2 = 17,
AnnulationAbsence = 18,
AnnulationDemande = 19,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/AbsenceHistoriqueTypeActionEnum.ts